// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================
   Global Fix (خیلی مهم)
============================= */
*,
*::before,
*::after {
  box-sizing: border-box;
}

.pb-container {
  padding: 32px 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* =============================
   Header
============================= */
.pb-title {
  margin-bottom: 6px;
}

.pb-subtitle {
  margin-bottom: 20px;
  opacity: 0.7;
}

/* =============================
   Grid Layout
============================= */
.pb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.pb-wide {
  margin-bottom: 24px;
}

.pb-lists {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
}

/* =============================
   Cards
============================= */
.pb-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0,0,0,0.05);
  width: 100%;
  overflow: hidden; /* جلوگیری از بیرون زدگی */
}

.pb-card h2 {
  margin-bottom: 16px;
}

/* =============================
   Form Elements
============================= */
.pb-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 14px;
}

.pb-input,
.pb-select,
.pb-textarea {
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  outline: none;
  margin-bottom: 14px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.pb-input:focus,
.pb-select:focus,
.pb-textarea:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
}

.pb-textarea {
  resize: vertical;
  min-height: 80px;
}

/* =============================
   Buttons
============================= */
.pb-button {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  background: #0d6efd;
  color: white;
  transition: all 0.2s ease;
}

.pb-button:hover {
  background: #0b5ed7;
}

/* =============================
   Row Form (Add Tag Section)
============================= */
.pb-row-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  align-items: end;
}

.pb-col {
  display: flex;
  flex-direction: column;
}

.pb-col-btn {
  display: flex;
  align-items: end;
}

/* =============================
   Lists
============================= */
.pb-list {
  margin-top: 10px;
}

.pb-list-item {
  padding: 14px;
  border-radius: 10px;
  border: 1px dashed rgba(0,0,0,0.1);
  margin-bottom: 12px;
  background: #fafafa;
}

.pb-list-title {
  font-weight: 600;
}

.pb-list-sub {
  font-size: 13px;
  opacity: 0.6;
  margin-top: 4px;
}

/* =============================
   Badges
============================= */
.pb-badge {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid rgba(0,0,0,0.15);
  margin-left: 6px;
}

/* =============================
   Page Link Row
============================= */
.pb-page-link-row {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pb-page-link {
  color: #0d6efd;
  text-decoration: none;
  font-weight: 600;
  word-break: break-all;
}

.pb-page-link:hover {
  text-decoration: underline;
}

.pb-copy-btn {
  padding: 6px 10px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: #198754;
  color: white;
  font-size: 13px;
}

.pb-copy-btn:hover {
  background: #157347;
}

/* =============================
   Messages
============================= */
.pb-message {
  padding: 10px 14px;
  margin-bottom: 20px;
  border-radius: 10px;
  background: rgba(13, 110, 253, 0.08);
  border: 1px solid rgba(13, 110, 253, 0.2);
}

.pb-muted {
  opacity: 0.6;
  padding: 10px 0;
}

/* =============================
   Responsive Fix
============================= */
@media (max-width: 768px) {
  .pb-container {
    padding: 20px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PageBuilder.css"],"names":[],"mappings":"AAAA;;+BAE+B;AAC/B;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;;+BAE+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;+BAE+B;AAC/B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;;+BAE+B;AAC/B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kCAAkC;EAClC,WAAW;EACX,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+BAE+B;AAC/B;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;+BAE+B;AAC/B;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+BAE+B;AAC/B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;+BAE+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;;+BAE+B;AAC/B;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;+BAE+B;AAC/B;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+BAE+B;AAC/B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;+BAE+B;AAC/B;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* =============================\n   Global Fix (خیلی مهم)\n============================= */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n.pb-container {\n  padding: 32px 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* =============================\n   Header\n============================= */\n.pb-title {\n  margin-bottom: 6px;\n}\n\n.pb-subtitle {\n  margin-bottom: 20px;\n  opacity: 0.7;\n}\n\n/* =============================\n   Grid Layout\n============================= */\n.pb-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.pb-wide {\n  margin-bottom: 24px;\n}\n\n.pb-lists {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 20px;\n}\n\n/* =============================\n   Cards\n============================= */\n.pb-card {\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 20px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0,0,0,0.05);\n  width: 100%;\n  overflow: hidden; /* جلوگیری از بیرون زدگی */\n}\n\n.pb-card h2 {\n  margin-bottom: 16px;\n}\n\n/* =============================\n   Form Elements\n============================= */\n.pb-label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.pb-input,\n.pb-select,\n.pb-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #dcdcdc;\n  outline: none;\n  margin-bottom: 14px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.pb-input:focus,\n.pb-select:focus,\n.pb-textarea:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);\n}\n\n.pb-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* =============================\n   Buttons\n============================= */\n.pb-button {\n  width: 100%;\n  padding: 10px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  background: #0d6efd;\n  color: white;\n  transition: all 0.2s ease;\n}\n\n.pb-button:hover {\n  background: #0b5ed7;\n}\n\n/* =============================\n   Row Form (Add Tag Section)\n============================= */\n.pb-row-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  align-items: end;\n}\n\n.pb-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.pb-col-btn {\n  display: flex;\n  align-items: end;\n}\n\n/* =============================\n   Lists\n============================= */\n.pb-list {\n  margin-top: 10px;\n}\n\n.pb-list-item {\n  padding: 14px;\n  border-radius: 10px;\n  border: 1px dashed rgba(0,0,0,0.1);\n  margin-bottom: 12px;\n  background: #fafafa;\n}\n\n.pb-list-title {\n  font-weight: 600;\n}\n\n.pb-list-sub {\n  font-size: 13px;\n  opacity: 0.6;\n  margin-top: 4px;\n}\n\n/* =============================\n   Badges\n============================= */\n.pb-badge {\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid rgba(0,0,0,0.15);\n  margin-left: 6px;\n}\n\n/* =============================\n   Page Link Row\n============================= */\n.pb-page-link-row {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pb-page-link {\n  color: #0d6efd;\n  text-decoration: none;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.pb-page-link:hover {\n  text-decoration: underline;\n}\n\n.pb-copy-btn {\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  background: #198754;\n  color: white;\n  font-size: 13px;\n}\n\n.pb-copy-btn:hover {\n  background: #157347;\n}\n\n/* =============================\n   Messages\n============================= */\n.pb-message {\n  padding: 10px 14px;\n  margin-bottom: 20px;\n  border-radius: 10px;\n  background: rgba(13, 110, 253, 0.08);\n  border: 1px solid rgba(13, 110, 253, 0.2);\n}\n\n.pb-muted {\n  opacity: 0.6;\n  padding: 10px 0;\n}\n\n/* =============================\n   Responsive Fix\n============================= */\n@media (max-width: 768px) {\n  .pb-container {\n    padding: 20px 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
